import PropTypes from 'prop-types'
import React, { useContext, useEffect, useState } from 'react'
import slugify from 'react-slugify'
import Context from '../../context'
import { checkSlug } from '../../services/ClubeApi'

function SlugSeoDescription({ editing, checkValue, checkIsRed }) {
  const { formObject, setFormObject, setOpenToast } = useContext(Context)
  const [tempSlug, setTempSlug] = useState('')
  const [warnClass, setWarnClass] = useState('')

  useEffect(() => {
    if (editing) {
      setTempSlug(formObject.slug)
    }
  }, [])

  const slugifyText = () => {
    setFormObject({
      ...formObject,
      slug: slugify(formObject.slug)
    })

    if (formObject.slug.length > 0) {
      checkSlug(slugify(formObject.slug)).then(r => {
        if (!r && tempSlug !== formObject.slug) {
          setOpenToast({
            open: true,
            message: 'Slug não disponível, favor inserir outro.',
            type: 'error'
          })
          setWarnClass('clube-border-danger')
        } else {
          setOpenToast({
            open: false,
            message: '',
            type: 'error'
          })
          setWarnClass('')
        }
      })
    } else {
      checkValue('slug', formObject.slug)
    }
  }

  return (
    <div className="form-row">
      <div className="form-group col-12">
        <input
          value={formObject.slug || ''}
          onChange={e => setFormObject({ ...formObject, slug: e.target.value })}
          type="text"
          className={`form-control ${warnClass} ${checkIsRed('slug') && 'clube-border-danger'}`}
          placeholder="Slug"
          onBlur={slugifyText}
        />
      </div>
      <div className="form-group col-12">
        <textarea
          value={formObject.seoDescription || ''}
          onChange={e => setFormObject({ ...formObject, seoDescription: e.target.value })}
          className={`form-control ${checkIsRed('seoDescription') && 'clube-border-danger'}`}
          rows="4"
          placeholder="Descrição SEO"
          onBlur={e => checkValue('seoDescription', e.target.value)}
        />
      </div>
    </div>
  )
}

SlugSeoDescription.defaultProps = {
  editing: false,
  checkValue: () => {},
  checkIsRed: () => {}
}

SlugSeoDescription.propTypes = {
  editing: PropTypes.bool,
  checkValue: PropTypes.func,
  checkIsRed: PropTypes.func
}

export default SlugSeoDescription
